import {Component, OnDestroy, OnInit} from '@angular/core';
import {CarritoService} from '../../../servicios/pedido/carrito.service';
import {SubscriptionLike} from 'rxjs';
import {UserloginService} from "../../../servicios/usuario/userlogin.service";

@Component({
  selector: 'app-carrito-btn',
  templateUrl: './carrito-btn.component.html',
  styleUrls: ['./carrito-btn.component.css']
})
export class CarritoBTNComponent implements OnInit, OnDestroy {
  public cantidad:string;

  private sub:SubscriptionLike;
  private sub2:SubscriptionLike;

  public cliCodigo:number=0;
  public isMinorista:boolean=true;

  constructor(private carSV:CarritoService,private usuarioLog:UserloginService) {
    this.sub=null;
    this.sub2=null;
  }

  ngOnInit(): void {
    this.sub=this.carSV.cantidad$.subscribe(res=>{
      this.cantidad=res;
    })
    this.sub2=this.usuarioLog.currentUser.subscribe(res=>{
      this.cliCodigo=res!=null?parseInt(res.cliCodigo):0;
      this.isMinorista=res==null||res.cliCodigo==='0' ||res.cliCodigo==='10780';
    });
  }

  ngOnDestroy(): void {
    if(this.sub!=null) {
      this.sub.unsubscribe();
    }
    if(this.sub2!=null){
      this.sub2.unsubscribe();
    }
  }

}
